import {
  Button,
  FieldText,
  FieldTextarea,
  FlexBox,
  Text,
} from '@dixa/lib-shared-habla';
import { NotificationPayloadT } from 'lib-shared-legacy-types';
import moment from 'moment-timezone';
import { useRef, useState } from 'react';
import { Field } from 'redux-form';


import { extractPkcs12 } from '../../platforms';

import styles from './submitModal.module.scss';

interface Props {
  certPassword?: string;
  addNotification: (payload: NotificationPayloadT) => void;
  change: (field: string, value: string) => void;
  resetForm: () => void;
}

export function ApnsControls({
  certPassword,
  addNotification,
  change,
  resetForm,
}: Props): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);
  const [certFile, setCertFile] = useState<File | null>(null);
  const onFile = (e) => {
    if (e.currentTarget.files.length === 0) {
      return;
    }

    const [file] = e.currentTarget.files || [];
    setCertFile(file);
    resetForm();
  };

  const setCredentials = async () => {
    if (!certFile) {
      console.warn('No file to read.');
      return;
    }

    const buff = await certFile.arrayBuffer();
    const result = extractPkcs12(buff, certPassword);
    if (!result) {
      addNotification({
        title: 'Failed to extract certificate',
        text: `Make sure that certificate is valid and password is correct(if any)`,
        icon: 'exclamation',
        className: 'danger',
        time: 4000,
      });
      return;
    }

    change('platformCredential', result.privateKey);
    change('platformPrincipal', result.cert);
  };

  return (
    <>
      <FlexBox flexDirection="column" alignItems="flex-start">
        <Text.Heading className={styles.textSpacing} variant="heading-4">
          Choose the certificate to load credentials from
        </Text.Heading>
        <Button
          variant="secondary"
          onClick={() => {
            inputRef.current?.click();
          }}
        >
          Choose file
          <input
            className={styles.fileInput}
            ref={inputRef}
            accept="application/x-pkcs12"
            type="file"
            onChange={onFile}
          />
        </Button>
        <FlexBox className={styles.bottomSpacing} flexDirection="column">
          <Text.Input className={styles.textSpacing} variant="title">
            Valid .P12 files
          </Text.Input>
          {certFile ? (
            <>
              <Text.Heading className={styles.textSpacing} variant="heading-4">
                {certFile.name}
              </Text.Heading>
              <Text.Paragraph className={styles.fileDescription} variant="4">
                {moment(certFile.lastModified).format('L')}
              </Text.Paragraph>
            </>
          ) : null}
        </FlexBox>
      </FlexBox>
      {certFile ? (
        <>
          <Field
            component={FieldText}
            label="Certificate password"
            name="password"
            placeholder="Enter password"
            type="password"
          />
          <Button
            className={styles.bottomSpacing}
            variant="primary"
            onClick={setCredentials}
          >
            Load credentials from file
          </Button>
        </>
      ) : null}
      <Field
        component={FieldTextarea}
        label="Certificate"
        name="platformPrincipal"
        placeholder="Apple certificate"
        required
        type="text"
      />
      <Field
        component={FieldTextarea}
        label="Private key"
        name="platformCredential"
        placeholder="Apple private key"
        required
        type="text"
      />
    </>
  );
}
